import Logout from './middlewares/Logout';
import ResetCode from './middlewares/ResetCode';
import LoginScrapRedirect from './middlewares/LoginScrapRedirect';
import ValidateTokens from './middlewares/ValidateTokens';

export default (() => {
	const readOnlyMiddlewares = [
		LoginScrapRedirect,
	];

	const middleswares = [
		Logout,
		ResetCode,
		ValidateTokens,
	];

	const run = (to, from, next) => {
		readOnlyMiddlewares.forEach(middleware => middleware.run(to, from));
		for (let i = 0; i < middleswares.length; i += 1) {
			const stop = middleswares[i].run(to, from, next);
			if (stop) return;
		}
		next();
	};

	return {
		use: (router) => {
			// Subscribe to before each
			router.beforeEach(run);
		},
	};
})();
